"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CsBsKvsDebug = void 0;
var index_1 = require("../index");
var CsBsKvsDebug = /** @class */ (function () {
    /**
     * Creates an instance of CsBsKvsDebug.
     * @memberof CsBsKvsDebug
     */
    function CsBsKvsDebug(clearData) {
        if (clearData === void 0) { clearData = false; }
        if (index_1.CsBsKvsStorage.storageAvailable()) {
            this.csBsKvsStorage = new index_1.CsBsKvsStorage('csbskvslog');
            if (clearData)
                this.csBsKvsStorage.clear();
        }
    }
    /**
     * 取得
     */
    CsBsKvsDebug.prototype.get = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var responce, orgList_1, list_1, resultList, result;
            return __generator(this, function (_a) {
                if (this.csBsKvsStorage) {
                    orgList_1 = this.csBsKvsStorage.get();
                    list_1 = [];
                    // data_name が一致するものを探す
                    data.key_values.forEach(function (key_value) {
                        var tmp = orgList_1.filter(function (x) { return x.data_name === key_value.data_name; });
                        if (tmp)
                            list_1 = list_1.concat(tmp);
                    });
                    resultList = list_1.filter(function (x) { return x.app_id == data.app_id; });
                    result = [];
                    if (resultList) {
                        result = resultList.map(function (x) {
                            return x.payload.key_values[0];
                        });
                    }
                    // レスポンスを作成
                    responce = JSON.parse(JSON.stringify(data));
                    responce.key_values = result;
                }
                else {
                    // レスポンスを作成
                    responce = JSON.parse(JSON.stringify(data));
                    responce.key_values = [];
                }
                return [2 /*return*/, responce];
            });
        });
    };
    /**
     * 登録
     */
    CsBsKvsDebug.prototype.post = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.csBsKvsStorage) {
                    index_1.CsBsKvsStorageUtil.pushData({
                        storage: this.csBsKvsStorage,
                        data: data,
                        groupId: this.csBsKvsStorage.getNewGroupId(),
                        apiRegist: false,
                        hasError: false,
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * 更新
     */
    CsBsKvsDebug.prototype.put = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // postと同一の動作
                return [2 /*return*/, this.post(data)];
            });
        });
    };
    /**
     * 削除
     */
    CsBsKvsDebug.prototype.delete = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.csBsKvsStorage) {
                    data.key_values.forEach(function (key_value) {
                        if (_this.csBsKvsStorage) {
                            _this.csBsKvsStorage.delete({
                                app_id: data.app_id,
                                data_name: key_value.data_name,
                                hasError: false,
                                apiRegist: false,
                            });
                        }
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return CsBsKvsDebug;
}());
exports.CsBsKvsDebug = CsBsKvsDebug;
//# sourceMappingURL=CsBsKvsDebug.js.map